import { ForbiddenError } from "./ForbiddenError.js";
class PreviewTokenExpiredError extends ForbiddenError {
}
export {
  PreviewTokenExpiredError
};
//# sourceMappingURL=PreviewTokenExpired.js.map
